import { createSlice } from "@reduxjs/toolkit";

const initialEChannelKurbanState = {
    listLoading: false,
    actionsLoading: false,
    totalCount: 0,
    entities: null,
    bankProcess: undefined,
    lastError: null,
}

export const callTypes = {
    list: "list",
    action: "action"
};

export const eChannelKurbanSlice = createSlice({
    name: 'eChannelKurban',
    initialState: initialEChannelKurbanState,
    reducers: {
        catchError: (state, action) => {
            // state.error = `${action.type}: ${action.payload.error}`;
            state.error = action.payload.error;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        startCall: (state, action) => {
            state.error = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = true;
            } else {
                state.actionsLoading = true;
            }
        },
        // getBankStatementById
        eChannelKurbanFetched : (state, action) => {
            state.actionsLoading = false;
            state.error = null;
            // state.bankProcess = action.payload.bankProcess;
        },
        // findBankStatement
        eChannelsKurbanFetched: (state, action) => {
            const { total_items, items } = action.payload;
            state.listLoading = false;
            state.error = null;
            state.entities = items;
            state.totalCount = total_items;
        },
        // Set to default state actionLoading & error
        eChannelKurbanReload: (state, action) => {
            state.actionsLoading = false;
            state.error = null;
        }

    }
});

